import { useState } from 'react';

const faqs = [
  { q: 'What happens after I request a proposal?', a: 'We review the details you send, reply to arrange a short call and, if it makes sense for both sides, schedule a walk-through of the property before preparing a written scope of services.' },
  { q: 'What size communities do you work with?', a: 'We work with residential communities of different sizes. Share the approximate number of units so we can better understand your needs.' },
  { q: 'I am a resident. Is this the right place for urgent issues?', a: 'This form is for non-urgent questions and requests. For emergencies such as fire, gas leaks or medical situations, contact local emergency services first. Urgent building issues should go through your community\u2019s posted after-hours line.' },
  { q: 'Do you manage individual rental units or sell homes?', a: 'No. We are not a real estate brokerage or rental listing service. Our focus is the shared operations of residential communities, which can include coordinating move-ins, turnover and unit readiness within the communities we manage.' },
  { q: 'Can we change the scope of services later?', a: 'Yes. Scopes are typically reviewed at least once a year, and changes can be discussed with the board or owner whenever needs shift.' },
];

export default function FaqList() {
  const [open, setOpen] = useState<number | null>(0);
  return (
    <ul className="border-t border-background-300">
      {faqs.map((f, i) => {
        const isOpen = open === i;
        return (
          <li key={f.q} className="border-b border-background-200">
            <h3>
              <button
                type="button"
                aria-expanded={isOpen}
                aria-controls={`faq-${i}`}
                onClick={() => setOpen(isOpen ? null : i)}
                className="flex min-h-[64px] w-full cursor-pointer items-center justify-between gap-6 py-4 text-left font-heading text-[18px] font-semibold text-foreground-950 md:text-[20px]"
              >
                {f.q}
                <span className={`flex h-6 w-6 shrink-0 items-center justify-center text-[20px] text-accent-500 transition-transform duration-[400ms] ease-[cubic-bezier(0.22,1,0.36,1)] motion-reduce:transition-none ${isOpen ? 'rotate-45' : 'rotate-0'}`}>
                  <i className="ri-add-line" aria-hidden="true"></i>
                </span>
              </button>
            </h3>
            <div
              id={`faq-${i}`}
              aria-hidden={!isOpen}
              inert={!isOpen}
              className={`grid transition-[grid-template-rows,opacity] duration-[450ms] ease-[cubic-bezier(0.22,1,0.36,1)] motion-reduce:transition-none ${isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`}
            >
              <div className="overflow-hidden">
                <div className={`max-w-[720px] pb-6 text-[16px] leading-[1.6] text-foreground-700 transition-transform duration-[450ms] ease-[cubic-bezier(0.22,1,0.36,1)] motion-reduce:transition-none ${isOpen ? 'translate-y-0' : '-translate-y-2'}`}>
                  {f.a}
                </div>
              </div>
            </div>
          </li>
        );
      })}
    </ul>
  );
}